const focusableSelector =
  'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])';

const getFocusable = $modalEl => Array.from($modalEl?.querySelectorAll(focusableSelector) || []);

const setModalOpen = ({ modalEl: $modalEl, isOpen, busyOnOpen }) => {
  if (!$modalEl) return;
  $modalEl.classList.toggle("is-open", isOpen);
  $modalEl.setAttribute("aria-hidden", (!isOpen).toString());
  if (isOpen) {
    $modalEl.setAttribute("aria-busy", busyOnOpen ? "true" : "false");
    document.body.style.overflow = "hidden";
    return;
  }
  $modalEl.setAttribute("aria-busy", "false");
  document.body.style.overflow = "";
};

const handleModalKeydown = (
  event,
  { getFocusable: getFocusableFn, dialogEl: $dialogEl, onEscape, allowEscape }
) => {
  if (event.key === "Escape") {
    const escapeAllowed = typeof allowEscape === "function" ? allowEscape() : allowEscape;
    if (escapeAllowed && onEscape) onEscape();
    return;
  }

  if (event.key !== "Tab") return;
  const $focusable = typeof getFocusableFn === "function" ? getFocusableFn() : [];
  if (!$focusable.length) return;
  const $first = $focusable[0];
  const $last = $focusable[$focusable.length - 1];
  const $active = document.activeElement;
  const isAtDialog = $dialogEl && $active === $dialogEl;
  if (event.shiftKey && ($active === $first || isAtDialog)) {
    $last.focus();
    event.preventDefault();
  } else if (!event.shiftKey && ($active === $last || isAtDialog)) {
    $first.focus();
    event.preventDefault();
  }
};

export { focusableSelector, getFocusable, handleModalKeydown, setModalOpen };
